import { listOfStringsTypeFiltersCombiner } from "./listOfStringsTypeFiltersCombiner";
import { RootState } from "../../../../store";
import { resourceExplorerAppliedFiltersSelector } from "../resourceExplorerAppliedFiltersSelector";

export const appliedRegionsSelector = (state: RootState) => {
  const filters = resourceExplorerAppliedFiltersSelector(state);

  return listOfStringsTypeFiltersCombiner("region", filters);
};
